import { siteOperatorListPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'
import { SiteOperator } from '@/common/model/siteOperator'

import BackButton from '@/components/view/atoms/button/BackButton'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'

import SiteOperatorForm from '@/components/container/form/modules/site/operator/SiteOperatorForm'

interface Props {
  operator?: SiteOperator
  onRefetch?: () => void
}

const SiteOperatorEditPage = ({ operator, onRefetch }: Props) => {
  const siteId = useSiteId()
  return (
    <Main type={MainLayoutType.SMALL}>
      <BackButton link={siteOperatorListPath(siteId)} />
      <SiteOperatorForm operator={operator} onRefetch={onRefetch} />
    </Main>
  )
}

export default SiteOperatorEditPage
